<template>
  <ValidationProvider v-slot="{ errors }" tag="div" :rules="rules" class="lv-number-stepper-field">
    <div
      class="lv-number-stepper"
      :class="{
        'lv-number-stepper--disabled': disabled,
        'lv-number-stepper--error': errors.length > 0,
      }"
    >
      <button
        type="button"
        class="lv-number-stepper__btn"
        :disabled="disabled || _isMin"
        @click="$_onStep(-step)"
      >
        −
      </button>
      <input
        type="text"
        inputmode="numeric"
        class="lv-number-stepper__input"
        :value="_displayValue"
        :disabled="disabled"
        @input="$_onInput($event)"
      />
      <button
        type="button"
        class="lv-number-stepper__btn"
        :disabled="disabled || _isMax"
        @click="$_onStep(step)"
      >
        +
      </button>
    </div>
    <input type="hidden" :value="value" />
    <LvFlexBox
      v-if="errors.length > 0"
      noWrap
      gap4
      alignItems="flex-start"
      class="lv-number-stepper-field__error mt-8"
    >
      <LvIcon icon="icon-warning" size="1rem" class="lv-number-stepper-field__error-icon" />
      <LvText remark red minWidth0>{{ $t(errors[0]) }}</LvText>
    </LvFlexBox>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: '此項目為必填',
});

export default {
  components: {
    ValidationProvider,
  },
  props: {
    value: {
      type: Number,
      default: null,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: null,
    },
    step: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: '',
    },
  },
  computed: {
    _displayValue() {
      return this.value === null ? '' : this.value;
    },
    _isMin() {
      return this.value !== null && this.value <= this.min;
    },
    _isMax() {
      return this.max !== null && this.value !== null && this.value >= this.max;
    },
  },
  methods: {
    $_clamp(number) {
      const minClamped = Math.max(this.min, number);
      return this.max === null ? minClamped : Math.min(this.max, minClamped);
    },
    $_onStep(delta) {
      const base = this.value === null ? this.min : this.value + delta;
      this.$emit('input', this.$_clamp(base));
    },
    $_onInput($event) {
      const digits = $event.target.value.replace(/[^0-9]/g, '');
      const number = digits === '' ? null : this.$_clamp(Number(digits));
      // 非數字或超出範圍時，把輸入框內容同步回實際的值
      $event.target.value = number === null ? '' : number;
      this.$emit('input', number);
    },
  },
};
</script>
